import { connect } from 'react-redux';
import { getEditorOptions } from 'selectors/options';
import SelectOptionField from './SelectOptionField';


const mapStateToProps = (state) => {
  return {
    name: 'editor',
    label: 'Editor',
    options: getEditorOptions(state),
  }
}

export default connect(
  mapStateToProps,
)(SelectOptionField);

